import { Button, Popover, PopoverContent, PopoverTrigger } from '@heroui/react'
import { HexColorInput, HexColorPicker } from 'react-colorful'
import { Controller, useFormContext } from 'react-hook-form'

export function ColorPickerField({ name, label }) {
  const { control } = useFormContext()
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Popover placement="top">
          <PopoverTrigger>
            <Button variant="bordered" size="md" className="w-fit" radius="none">
              <div
                className="h-4 w-4 rounded-full border"
                style={{ backgroundColor: field.value }}
              />
              {label}
            </Button>
          </PopoverTrigger>
          <PopoverContent>
            <div className="flex flex-col gap-2 p-2">
              <HexColorPicker color={field.value} onChange={field.onChange} />
              <div className="flex items-center justify-between gap-2">
                <span className="text-gray-600">Hex Value</span>
                <div className="flex items-center gap-2">
                  <span className="text-base">#</span>
                  <HexColorInput
                    color={field.value}
                    onChange={field.onChange}
                    className={`
                      flex w-20 border border-input bg-background px-3 py-1.5
                      text-sm ring-offset-background
                      file:border-0 file:bg-transparent file:text-xs
                      file:font-medium
                      placeholder:text-muted-foreground
                      focus-visible:ring-2 focus-visible:ring-ring
                      focus-visible:ring-offset-2 focus-visible:outline-hidden
                      disabled:cursor-not-allowed disabled:opacity-50
                    `}
                  />
                </div>
              </div>
            </div>
          </PopoverContent>
        </Popover>
      )}
    />
  )
}
